const API_URL = process.env.REACT_APP_API_URL;

export const pingServer = async () => {
  try {
    const response = await fetch(`${API_URL}/ping`);
    const data = await response.text();
    return data;
  } catch (error) {
    console.error("Ping error:", error);
    return null;
  }
};
